import {
    ExactSign,
    Filter,
    isExactFilter,
    isMembershipFilter,
    MembershipSign,
} from 'utils/filter/filter';
import StringExpression from 'utils/filter/expressions/StringExpression';
import MembershipStringExpression from '../expressions/MembershipStringExpression';

export default function buildStringFilterFunction(filter: Filter<string>) {
    if (isExactFilter(filter)) {
        const expression = new StringExpression(filter.value);
        switch (filter.exactSign) {
            case ExactSign.EQ:
                return expression.testContains.bind(expression);
            case ExactSign.NEQ:
                return expression.testNotContains.bind(expression);
            default:
                return () => true;
        }
    } else if (isMembershipFilter(filter)) {
        const expression = new MembershipStringExpression(filter.values);
        switch (filter.membershipSign) {
            case MembershipSign.INCLUDE:
                return expression.testIsOneOf.bind(expression);
            case MembershipSign.EXCLUDE:
                return expression.testNotIsOneOf.bind(expression);
            case MembershipSign.CONTAINS:
                return expression.testContainsOneOf.bind(expression);
            case MembershipSign.NOTCONTAINS:
                return expression.testNotContainsOneOf.bind(expression);
            case MembershipSign.STARTSWITH:
                return expression.testStartsWithOneOf.bind(expression);
            case MembershipSign.ENDSWITH:
                return expression.testEndsWithOneOf.bind(expression);
            case MembershipSign.BLANK:
                return expression.testBlankOneOf.bind(expression);
            case MembershipSign.NOTBLANK:
                return expression.testNotBlankOneOf.bind(expression);
            default:
                return () => true;
        }
    }
    return () => true;
}
